// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const getData = state => state.homeReducer;
